import { useLocation, matchPath } from "react-router";

export const usePathname = () => {
  const { pathname } = useLocation();
  return {
    pathname,
    matches: (pattern: string) =>
      !!matchPath({ path: pattern, end: false }, pathname),
  };
};
